export default __webpack_public_path__ + "static/sangyulee-889733eac7382643174322b5bc9132d2.jpeg";